export function Spinner({}) {
  return <div className="border-t border-l border-r animate-spin border-gray-600 dark:border-gray-400 rounded-full w-8 h-8 mx-auto"></div>;
}

export function SpinnerSmall({}) {
    return <div className="border-t border-l border-r animate-spin border-gray-600 dark:border-gray-400 rounded-full w-4 h-4 mx-auto"></div>;
  }